import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const ListIconView: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33203 7.6013C1.33203 6.8291 1.49318 6.66797 2.26536 6.66797H13.732C14.5042 6.66797 14.6654 6.8291 14.6654 7.6013V8.4013C14.6654 9.1735 14.5042 9.33464 13.732 9.33464H2.26536C1.49318 9.33464 1.33203 9.1735 1.33203 8.4013V7.6013Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M1.33203 2.26536C1.33203 1.49318 1.49318 1.33203 2.26536 1.33203H13.732C14.5042 1.33203 14.6654 1.49318 14.6654 2.26536V3.06536C14.6654 3.83754 14.5042 3.9987 13.732 3.9987H2.26536C1.49318 3.9987 1.33203 3.83754 1.33203 3.06536V2.26536Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M1.33203 12.9333C1.33203 12.1611 1.49318 12 2.26536 12H13.732C14.5042 12 14.6654 12.1611 14.6654 12.9333V13.7333C14.6654 14.5055 14.5042 14.6667 13.732 14.6667H2.26536C1.49318 14.6667 1.33203 14.5055 1.33203 13.7333V12.9333Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
